export class EstimatesHttp {
    /**
     * Fetch estimates
     * @returns {Promise<void>}
     */
    static async fetchEstimates() {
        try {
            return await window.axios.get(`estimates`);
        } catch (e) {
            return await Promise.reject(e);
        }
    }

    /**
     * Fetch drafts
     * @returns {Promise<void>}
     */
    static async fetchDrafts() {
        try {
            return await window.axios.get(`estimates/drafts`);
        } catch (e) {
            return await Promise.reject(e);
        }
    }

    /**
     * Creates a new estimate
     * @param estimate
     * @returns {Promise<void>}
     */
    static async createNewEstimate(estimate) {
        try {
            return await window.axios.post(`estimates`, estimate);
        } catch (e) {
            return await Promise.reject(e);
        }
    }

    /**
     * Update an existing estimate
     * @param id
     * @param estimate
     * @param ignore
     * @returns {Promise<AxiosResponse<any>>}
     */
    static async updateExistingEstimate(id, estimate, ignore) {
        let doIgnore = true;
        if (!ignore) {
            doIgnore = false;
        }
        try {
            return await window.axios.put(`estimates/${id}?ignore=${doIgnore}`, estimate);
        } catch (e) {
            return await Promise.reject(e);
        }
    }

    /**
     * Deletes an estimate
     * @param id
     * @returns {Promise<void>}
     */
    static async deleteEstimate(id) {
        try {
            return await window.axios.delete(`estimates/${id}`);
        } catch (e) {
            return await Promise.reject(e);
        }
    }

    /**
     * Search for estimates
     * @param q
     * @returns {Promise<AxiosResponse<any>>}
     */
    static async searchForEstimates(q) {
        try {
            return await window.axios.get(`estimates/search/${q}`);
        } catch (e) {
            return await Promise.reject(e);
        }
    }

    /**
     * Search for customer by id
     * @param id
     * @returns {Promise<AxiosResponse<any>>}
     */
    static async searchByCustomerId(id) {
        try {
            return await window.axios.get(`estimates/search/customer/${id}`).then(result => result.data);
        } catch (e) {
            return await Promise.reject(e);
        }
    }

    /**
     * Get an estimate
     * @param id
     * @returns {Promise<void>}
     */
    static async fetchEstimate(id) {
        try {
            return await window.axios.get(`public/estimates/${id}`).then(result => result.data);
        } catch (e) {
            return await Promise.reject(e);
        }
    }

    /**
     * Prints an estimate
     * @param id
     */
    static async printEstimate(id) {
        try {
            return await window.axios.get(`public/estimates/print/${id}`, {responseType: 'arraybuffer',headers: {
                    'Accept': 'application/pdf'
                }}).then(result => {
                return new Blob([result.data], {type: 'application/pdf'});
            });
        } catch (e) {
            return await Promise.reject(e);
        }
    }

    /**
     * Email estimate to customer
     * @param id
     * @returns {Promise<AxiosResponse<any>>}
     */
    static async emailEstimate(id) {
        try {
            return await window.axios.post(`estimates/email/${id}`).then(result => result.data);
        } catch (e) {
            return await Promise.reject(e);
        }
    }
}
